import { FC } from "react";
import { Flex } from "@chakra-ui/react";
import { Check } from "~/icons";

export const CheckCircle: FC = () => {
  return (
    <Flex
      align="center"
      borderRadius="100%"
      bg="th.blueGreen2"
      h={{ base: "1.875rem", md: 10 }}
      justify="center"
      w={{ base: "1.875rem", md: 10 }}
    >
      <Check color="th.white" h={{ base: 5, md: 6 }} w={{ base: 5, md: 6 }} />
    </Flex>
  );
};
